export default __webpack_public_path__ + "static/media/other_stops.a5d0b1dc.svg";